import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { formatPhoneNumber } from "@tFissco/Common/Utilities/formatPhoneNumber";
import { CallbackType, ErrorObjectType, InputObjectType, validate } from "@tFissco/Common/Utilities/validate";
import {
    FormErrorsStateType,
    intialErrorFormState,
    trainingAndTestingValidatorConfig,
    ValidatorConfigType,
} from "@tFissco/Components/TrainingAndTestingFormValidatorConfig";
import submitTrainingAndTesting from "@tFissco/Handlers/TrainingAndTestingHandler";
import SelectDropdown from "@tFissco/Icons/SelectDropdown";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface SelectList {
    fields: {
        SelectList: string;
    };
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
        [fields.selectLocation]: SelectList[];
        [fields.showPaymentText]: boolean;
        [fields.companyNameRequired]: boolean;
    };
}
const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
    selectLocation = "selectLocation",
    showPaymentText = "showPaymentText",
    companyNameRequired = "companyNameRequired",
}
const mapDispatchToProps = {
    submitTrainingAndTesting,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface TrainingAndTestingStyles {
    formWrapper?: InjectableCss;
    mainGridContainer?: GridContainerProps;
    fullWidth?: InjectableCss;
    submitGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    emailTextField?: TextFieldPresentationProps;
    TrainingAndTestingSectionwrapper?: GridContainerProps;
    TrainingAndTestingTitleWrapper?: GridItemProps;
    TrainingAndTestingSectionTitle?: TypographyProps;
    userGridContainer?: GridItemProps;
    creatAccountfileldLayout?: GridItemProps;
    titleOne: TypographyProps;
    titleTwo: TypographyProps;
    selectDropdown: SelectPresentationProps;
}

export const trainingAndTestingStyles: TrainingAndTestingStyles = {
    formWrapper: {
        css: css`
            margin-top: 20px;
            margin-bottom: 20px;
            h4 {
                font-weight: 600;
            }
            .fullWidthForMobileDevices {
                > div {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    width: 100% !important;
                                `,
                            ],
                            "max",
                        )}
                }
            }
            > div[class^="GridWrapper"] {
                margin-top: 10px;
                padding-left: 0;
                margin-bottom: 30px;
                > div[class^="GridOffset"] {
                    width: 100%;
                    margin: 0;
                }
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    border: 1px solid red;
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }
        `,
    },
    fullWidth: {
        css: css`
            width: 100%;
            > div[class^="RadioGroupStyle"] {
                justify-content: flex-start;
                display: inline-block;
                > div[class^="RadioStyle"] {
                    margin-top: 0;
                    margin-right: 20px;
                    display: inline-block;
                    &:last-child {
                        margin-right: 0;
                    }
                    > label[class^="TypographyStyle"] {
                        font-size: 13px;
                    }
                }
            }
        `,
    },
    submitGridItem: {
        width: 12,
        css: css`
            display: flex;
            justify-content: left;
            width: 100%;
            margin-block: 25px;
            flex-direction: column;
            gap: 30px;
        `,
    },
    submitButton: {
        css: css`
            margin-right: 10px;
            width: max-content;
        `,
    },

    TrainingAndTestingSectionwrapper: {
        css: css`
            background-color: ${getColor("secondary")};
            margin-bottom: 20px;
            border-radius: 10px;
            overflow: hidden;
            > ${GridOffset} {
                width: 100%;
                margin: 0px;
            }
        `,
    },
    TrainingAndTestingTitleWrapper: {
        width: 12,
        css: css`
            background: ${getColor("common.border")};
            padding: 11px 30px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        `,
    },
    TrainingAndTestingSectionTitle: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
            font-family: "MontserratRegular";
            color: ${getColor("text.accent")};
            font-weight: 700 !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 16px;
                    `,
                    css`
                        font-size: 16px;
                    `,
                    css`
                        font-size: 16px;
                    `,
                    css``,
                    null,
                ])}
        `,
    },
    userGridContainer: {
        width: [12, 12, 12, 12, 12],
        css: css`
            flex-wrap: wrap;
            display: flex;
        `,
    },
    creatAccountfileldLayout: {
        width: [12, 12, 6, 6, 4],
    },

    titleOne: {
        variant: "headerSecondary",
        size: 14,
        transform: "none",
        color: "text.accent",
        css: css`
            font-family: "MontserratMedium" !important;
            font-weight: 400;
            line-height: 1.5 !important;
        `,
    },
    titleTwo: {
        variant: "headerSecondary",
        size: 14,
        transform: "none",
        color: "text.accent",
        css: css`
            margin: 2rem 0rem;
            font-family: "MontserratMedium" !important;
            font-weight: 600;
            line-height: 1.5 !important;
        `,
    },

    selectDropdown: {
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
        },
    },
};

const styles = trainingAndTestingStyles;
const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required");
const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const TrainingAndTesting = ({ submitTrainingAndTesting, fields }: Props) => {
    const [isloading, setIsLoading] = React.useState(false);
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [company, setCompany] = React.useState("");
    const [phoneNumber, setPhoneNumber] = React.useState("");
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [emailError, setEmailError] = React.useState(emailRequiredFieldMessage);
    const [emailAddress, setEmail] = React.useState("");
    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const [locationAndDate, setLocationAndDate] = React.useState("");

    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const firstNameChangeHandler = (input: HTMLInputElement) => {
        setFirstName(input.value);
        validateHandler(input);
    };
    const lastNameChangeHandler = (input: HTMLInputElement) => {
        setLastName(input.value);
        validateHandler(input);
    };
    const companyNameHandler = (input: HTMLInputElement) => {
        setCompany(input.value);
        validateHandler(input);
    };

    const phoneChangeHandler = (input: HTMLInputElement) => {
        setPhoneNumber(formatPhoneNumber(input.value));
        validateHandler(input);
    };
    const emailChangeHandler = (input: HTMLInputElement) => {
        validateEmail(input.value);
        setEmail(input.value);
        validateHandler(input);
    };
    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    const validateHandler = (
        input: HTMLInputElement | HTMLSelectElement | any,
        customValidation?: CallbackType,
    ): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        const validatorConfig = trainingAndTestingValidatorConfig[input.name as keyof ValidatorConfigType];
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);

        if (isValidate === undefined) {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        } else {
            setFormErrors({
                ...formErrors,
                [input.name]: isValidate ? isValidate.errorMsg : isValidate,
            });
        }
        if (!validatorConfig.required && input.value === "") {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        }
        scrollToFirstFormError();
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    };
    const scrollToFirstFormError = () => {
        const firstErrorElement = document.querySelector("[data-test-selector='undefined-error']");
        if (firstErrorElement) {
            const formFieldParent = firstErrorElement.closest("[class*='FormFieldStyle']");
            if (!formFieldParent) {
                return;
            }
            const { top } = formFieldParent.getBoundingClientRect();
            window.scrollTo({
                top: top + window.pageYOffset - 250,
                left: 0,
                behavior: "smooth",
            });
        }
    };
    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };
    const submitHandler = () => {
        if (!isSubmitted) {
            setIsSubmitted(true);
            setIsLoading(true);
            const url = window.location.href.split("/").pop()?.replace(/-/g, " ");
            submitTrainingAndTesting({
                topic: url,
                firstName,
                lastName,
                company,
                phoneNumber,
                emailAddress,
                locationAndDate,
                onSuccess: () => {
                    clearForm();
                    setIsLoading(false);
                    window.location.href = "/ThankYou";
                },
            });
        }
    };

    const subjectChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const currval = event.target.value;
        setLocationAndDate(currval);
        validateHandler(event.currentTarget);
    };

    return (
        <StyledWrapper {...styles.formWrapper}>
            <GridContainer {...styles.mainGridContainer}>
                <StyledWrapper {...styles.fullWidth}>
                    <form autoComplete="off">
                        <GridContainer {...styles.TrainingAndTestingSectionwrapper}>
                            <GridItem {...styles.TrainingAndTestingTitleWrapper}>
                                <Typography {...styles.TrainingAndTestingSectionTitle}>Sign Up Here !</Typography>
                            </GridItem>
                            <GridItem {...styles.userGridContainer}>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("First Name")}
                                        value={firstName}
                                        data-test-selector="tAndt_firstName"
                                        onChange={e => firstNameChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.firstName && formErrors.firstName}
                                        name="firstName"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.firstName ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Last Name")}
                                        value={lastName}
                                        data-test-selector="tAndt_lastName"
                                        onChange={e => lastNameChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.lastName && formErrors.lastName}
                                        name="lastName"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.lastName ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Company Name")}
                                        value={company}
                                        data-test-selector="tAndt_company"
                                        onChange={e => companyNameHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={fields.companyNameRequired && !!formErrors.company && formErrors.company}
                                        name="company"
                                        iconProps={{
                                            color: "danger",
                                            src:
                                                fields.companyNameRequired && formErrors.company
                                                    ? AlertTriangle
                                                    : undefined,
                                        }}
                                        required={fields.companyNameRequired}
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        label={translate("Phone Number")}
                                        type="tel"
                                        list="autocompleteOff"
                                        autoComplete="new-password"
                                        aria-autocomplete="none"
                                        value={phoneNumber}
                                        data-test-selector="tAndt_phone"
                                        onChange={e => phoneChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.phoneNumber && formErrors.phoneNumber}
                                        name="phoneNumber"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.phoneNumber ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <TextField
                                        {...styles.emailTextField}
                                        type="email"
                                        label={translate("Email ID")}
                                        value={emailAddress}
                                        data-test-selector="tAndt_email"
                                        onChange={e => emailChangeHandler(e.currentTarget)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.emailAddress && formErrors.emailAddress}
                                        name="emailAddress"
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.emailAddress ? AlertTriangle : undefined,
                                        }}
                                        required
                                    />
                                </GridItem>
                                <GridItem {...styles.creatAccountfileldLayout}>
                                    <Select
                                        label={translate("Location")}
                                        value={locationAndDate}
                                        name="locationAndDate"
                                        onChange={e => subjectChangeHandler(e)}
                                        onBlur={e => validateHandler(e.currentTarget)}
                                        error={!!formErrors.locationAndDate && formErrors.locationAndDate}
                                        iconProps={{
                                            color: "danger",
                                            src: formErrors.locationAndDate ? AlertTriangle : SelectDropdown,
                                        }}
                                        required
                                    >
                                        <option value="">{translate("-- Select Location --")}</option>
                                        {fields.selectLocation?.map(division => (
                                            <option key={division.fields.SelectList} value={division.fields.SelectList}>
                                                {division.fields.SelectList}
                                            </option>
                                        ))}
                                    </Select>
                                </GridItem>
                            </GridItem>
                        </GridContainer>
                    </form>
                </StyledWrapper>
            </GridContainer>
            <Typography as="p" {...styles.titleOne}>
                *We will respond to your training request within 24 hours with a confirmation email, this email will
                include the phone number to call for your payment*
            </Typography>
            {fields.showPaymentText && (
                <>
                    <Typography as="p" {...styles.titleTwo}>
                        Payment is required beforehand to officially reserve a seat for your selected testing date.
                    </Typography>
                    <Typography as="p" {...styles.titleTwo}>
                        Credit Cards and PO’s are accepted for payment.
                    </Typography>
                </>
            )}
            <StyledWrapper {...styles.submitGridItem}>
                <Button
                    {...styles.submitButton}
                    onClick={submitHandler}
                    disabled={isButtonDisabled || isloading}
                    data-test-selector="trainingAndTesting_submitButton"
                >
                    {translate("Submit")}
                </Button>
                <Typography> * Required Fields </Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(TrainingAndTesting),
    definition: {
        displayName: "Training And Testing Form",
        group: "Contact Us",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.selectLocation,
                displayName: "Location",
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.SelectList;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "SelectList",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
            {
                name: fields.companyNameRequired,
                displayName: "Company Name Required?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "Contextual",
            },
            {
                name: fields.showPaymentText,
                displayName: "Show Payment Text",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                isEnabled: () => true,
                fieldType: "Contextual",
            },
        ],
    },
};
export default widgetModule;
